var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',{attrs:{"href":_vm.source,"target":"_blank"}},[_c('span',{class:_vm.$style.icon},[_c('question-circle-icon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }